import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablasComunesService from 'services/tablasComunes.service'

const OrigenFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const [origenes, setOrigenes] = React.useState([])

  React.useEffect(() => {
    TablasComunesService.getAsSelect(TiposTablaComunConstant.ORIGENES).then(({ data }) => {
      setOrigenes(data)
    })
  }, [])

  return (
    <Form.Group>
      <Form.Label text='ORIGEN' htmlFor='select-origen' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='origen'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-origen'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            >
              <option value=''>Seleccionar</option>
              {origenes.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(OrigenFormGroup)
